<template>
    <div>
        <main class="flex flex-col overflow-scroll border-gray-200 border rounded-2xl p-2 bg-white" :key="key">
            <div class="flex" v-if="users == null">
                Loading organization data....
            </div>
            <div v-else>
            </div>
        </main>
    </div>
</template>

<script>
import UiButton from "../ui/UiButton.vue";

export default {
    components: {UiButton},
    props: [],
    data() {
        return {
            key: 0
        }
    },
    watch: {},
    computed: {},
    methods: {},
    async mounted() {
    }
}
</script>
